import Confirmation from '@CS/components/Popups/Confirmation';
import HomeIcon from '@CS/assets/Vector/home.svg?component';
import { isStaging } from '@/utils/Location';
import Button from '@CS/components/Button';
import { useState } from 'react';

type CloseButtonProps = {
  translations: Record<string, string>;
};

export const CloseButton = ({ translations }: CloseButtonProps) => {
  const confirm = location.pathname === '/editor';
  const closeConfirm = () => setVisibleConfirm(false);

  const [visibleConfirm, setVisibleConfirm] = useState(false);
  const onSubmit = () => (location.href = home);

  const home = isStaging
    ? 'https://frontend-homepage.staging.mcd-it.platform-tbwa-x.com/fullscreen=true&appOrientation=portrait'
    : 'https://frontend-homepage.production.mcd-it.platform-tbwa-x.com/fullscreen=true&appOrientation=portrait'

  return (
    <>
      <Button
        onClick={(confirm && (() => setVisibleConfirm(true))) || void 0}
        link={(!confirm && home) || void 0}
        variant="iconFill"
        style={{
          left: 'min(6.4vmin, 24px)',
          top: 'min(12.8vmin, 48px)',
          position: 'fixed',
          display: 'block',
          zIndex: '2'
        }}
      >
        <HomeIcon />
      </Button>

      {visibleConfirm && (
        <Confirmation
          onSubmit={onSubmit}
          onCancel={closeConfirm}
          translations={translations}
        />
      )}
    </>
  );
};
